<!-- 旅游集市 mjs -->
<template>
  <div class="travelServe travelguidecontainer  pd100">
    <banner/>
    <!-- <div class="crumbs-1">
      <div class="container">
        <a href="/show/index">首页</a>
        <span>&gt;</span>
        <a href="#">旅游集市</a>
      </div>
    </div> -->
    <crumbs />
    <div class="container ">
      <div class="leftPart pb100 fl">
        <div class="labelBox">
          <type-screen modelType="touristmarket" :menu-id="menuId" @typeObj="selectType"/>
        </div>
        <div class="demoList clearfix">
          <div class="demoItem" @click.stop="detaillink(item)" v-for="(item) in marketlist" :key="item.id">
            <div class="innerbox">
              <div class="itemimg">
                <img :src="getImage(item.image)"  alt="">
              </div>
              <div class="itemtxt">
                <div class="title clearfix">
                  <h2>{{item.title}}</h2>
                </div>
                <div class="itemfun">
                   <span class="praisevalue">
                      <star
                        class="star"
                        starStyle="iconstar1"
                        :isSelect="item.isStar"
                        :count="item.star"
                        :menu-id="menuId"
                        :business-id="item.id"
                        @changecount="changePraise"
                        :title="item.title"
                        :image="item.image"
                        :url="'/touristmarketdetail?columnId=' + item.menuId + '&id=' + item.id"
                      ></star>
                  </span>
                  <span class="collection">
                <collect
                  collect-style="iconcollect1"
                  :is-select="item.isCollect"
                  :count="item.collect"
                  @changecount="changeCollect"
                  :menu-id="menuId"
                  :business-id="item.id"
                  :title="item.title"
                  :image="item.image"
                  :url="'/touristmarketdetail?columnId=' + item.menuId + '&id=' + item.id"
                ></collect>
                 </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <nodata v-show="nodataflag"/>
        <!-- 分页器 -->
        <el-pagination
          :page-size="20"
          :pager-count="5"
          layout="prev, pager, next"
          :total="total"
          background
          @prev-click="goprev"
          @next-click="gonext"
          @current-change="currentChange"
          class="pagemodel1">
        </el-pagination>

      </div>
      <div class="rightPart fr">
        <rightBox></rightBox>
      </div>
    </div>
  </div>
</template>

<script>
import {getListAmount, setupdateStar, setupdateCollect} from '@/api/datavolume/index'
import { isLogin } from '@/utils/index'
import crumbs from '@/components/crumbs/index'
import {getMarketlist} from '@/api/touristmarket/index'
import star from '@/components/amount/star'
import collect from '@/components/amount/collect'
import rightBox from '../../components/travelRight/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
import banner from '@/components/banner/index'
export default {
  name: 'touristmarket',
  components: {
    rightBox, typeScreen, crumbs, nodata, collect, star, banner
  },
  meta: {
    showHeader: true
  },
  data () {
    return {
      marketlist: [],
      marketparmas: {
        page: 1,
        limit: 12,
        menuId: '',
        areaType: '',
        productType: '',
        customTypeId: ''
      },
      total: 0,
      menuId: '',
      phoneNum: '',
      nodataflag: false
    }
  },
  created () {
    this.menuId = this.$route.query.columnId
    this.marketparmas.menuId = this.$route.query.columnId
    this.phoneNum = this.$cookie.get('wlymobilephone')
    this.getlist()
  },
  methods: {
    changeCollect (val) {
      this.marketlist.forEach(item => {
        if (item.id === val.id) {
          item.collect = val.count
          item.isCollect = val.isSelect
        }
      })
    },
    changePraise (val) {
      this.marketlist.forEach(item => {
        if (item.id === val.id) {
          item.star = val.count
          item.isStar = val.isSelect
        }
      })
    },
    defaultamout (list) {
      list.forEach(item => {
        if (item.collect === undefined) item.collect = 0
        if (item.isCollect === undefined) item.isCollect = 'false'
        if (item.star === undefined) item.star = 0
        if (item.isStar === undefined) item.isStar = 'false'
        if (item.pv === undefined) item.pv = 0
      })
    },
    getlist () {
      getMarketlist(this.marketparmas).then(res => {
        console.log(res)
        this.total = res.data.data.total
        if (this.total === 0) {
          this.nodataflag = true
        } else {
          this.nodataflag = false
        }
        const params = {
          p: this.$cookie.get('wlymobilephone')
        }
        // let that = this
        // getListAmount(this.menuId, params).then(res1 => {
        //   res1.data.data.forEach(item => {
        //     res.data.data.rows.forEach(val => {
        //       if (item.dataId === val.id) {
        //         let obj = {
        //           pv: item.pv,
        //           star: item.star,
        //           collect: item.collect,
        //           isCollect: item.isCollect,
        //           isStar: item.isStar
        //         }
        //         let newObj = {...val, ...obj}
        //         that.marketlist.push(newObj)
        //       }
        //     })
        //   })
        // })
        getListAmount(this.menuId, params).then(res1 => {
          console.log(res1, 'res1')

          if (res1.data.data.length !== 0) {
            res1.data.data.forEach(item => {
              res.data.data.rows.forEach(val => {
                if (item.dataId === val.id) {
                  val.collect = item.collect
                  val.isCollect = item.isCollect
                  val.pv = item.pv
                  val.isStar = item.isStar
                  val.star = item.star
                }
              })
            })
            this.defaultamout(res.data.data.rows)
          } else {
            this.defaultamout(res.data.data.rows)
          }
          this.marketlist = res.data.data.rows
        })
      })
    },
    getImage (val) {
      if (val === undefined || val === '') {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    selectType (obj) {
      this.marketparmas.areaType = obj.areaType
      this.marketparmas.productType = obj.productType
      this.marketparmas.customTypeId = obj.customTypeId
      this.marketlist = []
      this.getlist()
    },
    clickCollect (id, e) {
      // console.log()

      var param = {
        'menuId': this.menuId,
        'businessId': id,
        'webUserId': this.phoneNum
      }
      setupdateCollect(JSON.stringify(param)).then((res, e) => {
        console.log(res, '1111')
        if (res.data.status === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        } else {
          isLogin(res.data.message)
        }
      })
      if (e.currentTarget.className.indexOf('alcollected') !== -1) {
        e.currentTarget.classList.remove('alcollected')
        e.currentTarget.children[1].innerText = Number(e.currentTarget.children[1].innerText) - 1
      } else {
        e.currentTarget.classList.add('alcollected')
        e.currentTarget.children[1].innerText = Number(e.currentTarget.children[1].innerText) + 1
      }
    },
    clickPraise (id, e) {
      var param = {
        'menuId': this.menuId,
        'businessId': id,
        'webUserId': this.phoneNum
      }
      setupdateStar(JSON.stringify(param)).then(res => {
        console.log(res)

        if (res.data.status === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        } else {
          isLogin(res.data.message)
        }
      })

      if (e.currentTarget.className.indexOf('alpraised') !== -1) {
        e.currentTarget.classList.remove('alpraised')
        e.currentTarget.children[1].innerText = Number(e.currentTarget.children[1].innerText) - 1
      } else {
        e.currentTarget.classList.add('alpraised')
        e.currentTarget.children[1].innerText = Number(e.currentTarget.children[1].innerText) + 1
      }
    },
    // 下面的方法来控制分页，不同的分页方式
    goprev (e) {
      // 上一页
      console.log(e)
    },
    gonext (e) {
      // 下一页
      console.log(e)
    },
    currentChange (val) {
      // 当前的页
      console.log(val)
      this.marketparmas.page = val
      this.marketlist = []
      this.getlist()
    },
    detaillink (val) {
      if (val.url !== undefined && val.url !== '') {
        window.open(val.url)
      } else {
        this.$router.push({path: '/touristmarketdetail', query: {id: val.id, columnId: this.menuId}})
      }
    }
  },
  beforeDestroy () {
  }
}

</script>

<style lang='scss' scoped>
@import "../../assets/common/scss/travleServes.scss";
.alpraised i{
  background: url('~@/assets/common/icon/icon-group2.png') no-repeat !important;
  background-position: -64px 0px !important;
}
.alcollected i{
  background: url('~@/assets/common/icon/icon-group2.png') no-repeat !important;
  background-position: -64px -64px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/touristmarket/list.vue